module.exports = __webpack_public_path__ + "static/media/logo-white.ad93df84.svg";